import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const AlphaDisclaimer: React.FC = () => {
  const location = useLocation();
  const isTradFiPage = location.pathname === '/' || location.pathname.startsWith('/tradfi');
  
  if (isTradFiPage) {
    return (
      <div className="bg-blue-500/10 border-b border-blue-500/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2">
          <div className="flex items-center justify-center gap-2 text-blue-400">
            <Info className="w-4 h-4 flex-shrink-0" />
            <p className="text-xs sm:text-sm font-medium">
              TradFi page is still alpha but using real data, prototyping in public.
            </p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2">
        <div className="flex items-center justify-center gap-2 text-amber-500">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <p className="text-xs sm:text-sm font-medium">
            Alpha website with dummy data, prototyping in public.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AlphaDisclaimer;